var gftt = gftt || {};

(function($){
	'use strict';

	gftt.colorPickerChoicesDynamicPosition = function( form_id ) {
		var $formWrapper = ( typeof form_id !== "undefined" ) ? $('#gform_wrapper_'+form_id) : $(".gform_wrapper");
		$formWrapper.find('.color-picker-choice .gftt-icon').each(function(){
			var $icon = $(this);
			var $choice = $icon.parent();
			var $label = $choice.find('> label');
			var offset = ( $label.width() - $choice.width() ).toString();
			$icon.css('transform', 'translateX(' + offset + 'px)');
		});
	};

	gftt._initLabel = function( $label, forced ) {

		var $gfLabel = $label.closest('.gfield_label');
		if ( !$gfLabel.length ) {
			$gfLabel = $label.closest('.gform-field-label');
		}

		$gfLabel.on('click', function(e){
			e.preventDefault();
			e.stopImmediatePropagation();
		});

		$label.on('click', function(e){
			var $container = $(this).closest('.gfield').find('.ginput_container');
			if ($container.length) {
				if ( $container.find('input:first').not(':radio').not(':checkbox').length ) {
					$container.find('input:first').not(':radio').not(':checkbox').focus();
				}
				else if ( $container.find('textarea:first').length ) {
					$container.find('textarea:first').focus();
				}
				else if ( $container.find('select:first').length ) {
					$container.find('select:first').focus();
				}
			}
			var $choice = $(this).closest('[class*="gchoice"]');
			if ( $choice.length ) {
				$choice.find('input').click();
			}
		});

	};

	gftt._initTooltips = function( $el, forced ) {

		var tipID = $el.data('tid');
		var $tip = $('#'+tipID);
		var tipPlacement = $tip.data('placement');
		if (typeof tipPlacement === 'undefined' || tipPlacement === '') {
			tipPlacement = 'nw-alt';
		}
		$tip.data('powertiptarget', tipID+'-content');
		var userOptions = gform.applyFilters( 'gftt_tooltip_custom_options', {} );
		var mainOptions = {
			manual: false,
			followMouse: false,
			mouseOnToPopup: true,
			smartPlacement: true,
			popupClass: tipID,
			placement: tipPlacement
		};
		var options = $.extend( true, userOptions, mainOptions );
		$tip.powerTip(options);
		$tip.on({
			powerTipPreRender: function(){
				$('body').addClass('gftt_show');
			},
			powerTipRender: function(){
				var $self = $(this);
				$self.powerTip('reposition');
				$(document).trigger('gftt_tooltip_render', [this]);
			},
			powerTipOpen: function(){
				var $self = $(this);
				$self.data('tip-open', true);
				$(document).trigger('gftt_tooltip_open', [this]);
			},
			powerTipClose: function(){
				var $self = $(this);
				$self.data('tip-open', false);
				$('body').removeClass('gftt_show');
				$(document).trigger('gftt_tooltip_close', [this]);
			}
		});

		var $label = $el.closest('.gform-field-label').find('.gftt-label');
		gftt._initLabel( $label );

		var $icon = $el.closest('.gform-field-label').find('.gftt-icon');
		$icon.on('click', function(e){
			e.preventDefault();
			e.stopImmediatePropagation();
			var $self = $(this);
			if ( $self.data('tip-open') === true ) {
				$self.powerTip('hide');
			}
			else {
				$self.powerTip('show');
			}
		});

	};

	gftt.init = function( form_id, forced ){

		var $formWrapper = $('#gform_wrapper_'+form_id);

		/*
		var gfttHasInit = $formWrapper.data('gftt-init');
		if ( typeof gfttHasInit !== 'undefined' && gfttHasInit.toString() === 'true' && forced !== true ) {
			return;
		}
		*/

		$formWrapper.find('.gfield_label > .gftt-content > div, .gsection_title > .gftt-content > div').each(function(){
			var $this = $(this);
			gftt._initTooltips( $this );
		});

		$formWrapper.find('[class*="gchoice"] .gftt-content > div').each(function(){
			var $this = $(this);

			var $choice = $this.closest('[class*="gchoice"]');
			$choice.addClass('gform-theme__no-reset--children');

			gftt._initTooltips( $this );
		});


		var dynamicPosition = gform.applyFilters('gftt_dynamic_colorpicker_choices_position', true, form_id);
		if ( dynamicPosition ) {
			$(window).on('resize', function(){
				gftt.colorPickerChoicesDynamicPosition( form_id );
			});
			setTimeout(function(){
				gftt.colorPickerChoicesDynamicPosition( form_id );
			}, 100);
		}

		$formWrapper.data('gftt-init', true);

	}


/*
	gftt.gform_format_option_label = function(fullLabel, fieldLabel, priceLabel, selectedPrice, price, formId, fieldId, index) {

		//console.log({fullLabel, fieldLabel, priceLabel, selectedPrice, price, formId, fieldId, index})

		var markup = [fullLabel];

		formId = formId.toString();

		var $field = $('#gform_'+formId+' .gfield#field_'+formId+'_'+fieldId);
		var fieldKey = "field_" + fieldId;
		var fieldContent = ( window.hasOwnProperty('tooltipsOptionsContent') && window.tooltipsOptionsContent.hasOwnProperty( formId ) && window.tooltipsOptionsContent[ formId ].hasOwnProperty(fieldKey) ) ? window.tooltipsOptionsContent[ formId ][ fieldKey ] : false;

		if ( fieldContent !== false ) {

			var $allOptions = $field.find('[class*="gchoice"]');// TODO: Update to just .gchoice ?
			var $thisOption = (typeof index !== 'undefined' && index >= 0) ? $allOptions.eq(index) : $allOptions;// when index is not passed in or not valid, get all options (it does this with option field?)

			$thisOption.each(function(i){

				var $option = $(this);
				var optionKey = `${formId}_${fieldId}_${i}`;

				var $thisOptionLabel = $option.find('label');
				var $thisOptionInput = $option.find('input');

				// Copy of tooltip content stored in the global tooltipsOptionsContent object, grouped by form id, and then keys of option IDs with their tooltip content as value
				// See add_inline_options_label_lookup in class-gf-tooltips.php
				var thisOptionLabel = "";
				var thisOptionTooltip = "";
				var tooltipPlacement = "nw-alt";//default
				var tooltipTabindex = "";//default

				if ( fieldContent.length > i ) {
					thisOptionLabel = fieldContent[i].label;
					thisOptionTooltip = fieldContent[i].tooltip;
					tooltipPlacement = fieldContent[i].placement;
					tooltipTabindex = fieldContent[i].tabindex;
				}

				if ( !thisOptionTooltip ) {
					// continue
					return true;
				}

				var fallbackFieldLabel = thisOptionLabel;
				if ( (typeof fieldLabel === 'undefined' || fieldLabel === '') && fallbackFieldLabel !== '') {
					fieldLabel = fallbackFieldLabel;
				}

				if ( priceLabel === fieldLabel ) {
					priceLabel = "";
				}

				if ( priceLabel === "<span class='ginput_price'></span>" ) {
					priceLabel = "<span class='ginput_price'>&nbsp;</span>";
				}

				var tabindexAttr = (tooltipTabindex !== "") ? `tabindex="${tooltipTabindex}"` : "";

				markup = [
					`<gftt-label class="gftt-label">${fieldLabel}${priceLabel}</gftt-label>`,
					`<i class="gftt-icon gform-theme__no-reset--el" id="gftt-${optionKey}" data-placement="${tooltipPlacement}" ${tabindexAttr}></i>`,
					`<div id="gftt-${optionKey}-wrap" class="gftt-content" aria-hidden="false" role="tooltip"><div aria-hidden="false" id="gftt-${optionKey}-content" data-tid="gftt-${optionKey}">${thisOptionTooltip}</div></div>`,
				];

				setTimeout(function(){
					gftt._initTooltips( $option.find('.gftt-content > div') );
				}, 100);

			});

		}

		return markup.join('');
		//return gform.applyFilters( 'gftt_choice_html', markup.join(''), fieldLabel, priceLabel, selectedPrice, price, formId, fieldId, index );
	};
*/

	gftt.reInitOptions = function(formId, fieldId, index) {
		var $field = $('#gform_'+formId+' .gfield#field_'+formId+'_'+fieldId);
		var $allOptions = $field.find('[class*="gchoice"]');// TODO: Update to just .gchoice ?
		var $thisOption = (typeof index !== 'undefined' && index >= 0) ? $allOptions.eq(index) : $allOptions;// when index is not passed in or not valid, get all options (it does this with option field?)
		$thisOption.each(function(i){
			var $option = $(this);
			gftt._initTooltips( $option.find('.gftt-content > div') );
		});
	};

	window.gform_format_option_label = function(fullLabel, fieldLabel, priceLabel, selectedPrice, price, formId, fieldId, index) {

		var fieldKey = `tt_${formId}_${fieldId}`;
		if ( window.hasOwnProperty(fieldKey) ) {
			clearTimeout(window[fieldKey]);
		}
		window[fieldKey] = setTimeout(function(){
			gftt.reInitOptions( formId, fieldId, index );
		}, 100);

		var $field = $('#field_'+formId+'_'+fieldId);

		// Add for cross compat with Image Choices
		if ($field.length && $field.hasClass('image-choices-field') && typeof window.imageChoices_gform_format_option_label === 'function') {
			return window.imageChoices_gform_format_option_label(fullLabel, fieldLabel, priceLabel, selectedPrice, price, formId, fieldId, index);
		}


		// Add for cross compat with Color Picker
		if ( $field.length && $field.hasClass('color-picker-field') && typeof window.colorPicker_gform_format_option_label === 'function') {
			return window.colorPicker_gform_format_option_label(fullLabel, fieldLabel, priceLabel, selectedPrice, price, formId, fieldId, index);
		}

		return fullLabel;
	}


	$(document).on('gform_post_render', function(event, form_id, current_page){
		var globalDelay = ( window.hasOwnProperty('gf_tooltips_init_delay') ) ? parseInt( window.gf_tooltips_init_delay, 10 ) : 0;
		var delay = gform.applyFilters( 'gftt_tooltips_init_delay', globalDelay );
		if ( delay === 0 && $('#gform_' + form_id + ' .gpnf-nested-entries-container').length ) {
			// Seems we need to slightly delay the tooltip init if the form is using Gravity Wiz' Nested Forms and that field has a tooltip
			delay = 1;
		}
		if ( delay > 0 ) {
			setTimeout(function(){
				gftt.init( form_id );
			}, delay * 1000);
		}
		else {
			gftt.init( form_id );
		}
	});

})(jQuery);
